import matchSorter from "match-sorter";
import { Key } from "./utils.js";

const NOOP = () => {};

export async function createCombobox(
  $input,
  { getOptions, onSelect = NOOP, onClose = NOOP, onReady = NOOP, append } = {}
) {
  let $optionContainer = $input.nextElementSibling;
  let $list = $optionContainer.querySelector("ul");

  $input.value = "";

  if (getOptions) {
    let $spinner = $optionContainer.nextElementSibling;
    let spinnerTimeout = null;
    if ($spinner) {
      spinnerTimeout = window.setTimeout(() => {
        $spinner.hidden = false;
      }, 200);
    }

    let options = await Promise.resolve(getOptions());

    if ($spinner) {
      if (spinnerTimeout !== null) {
        window.clearTimeout(spinnerTimeout);
        spinnerTimeout = null;
      }
      $spinner.hidden = true;
    }

    let $optionTemplate = $list.querySelector("template").innerHTML;
    $list.innerHTML =
      `<template>${$optionTemplate}</template>` +
      options.reduce((html, option) => {
        return (
          html +
          $optionTemplate
            .replace(/{#if ([^}]+)}([\s\S]*?){\/if}/g, (m, p1, p2) => {
              return option[p1] ? p2 : ''
            }).replace(/\{([^}]+)\}/g, (_, p1) => {
              return option[p1];
            })
        );
      }, "") +
      (append
        ? $optionTemplate
            .replace(/<[a-z]+\b/, m => `${m} data-appended`)
            .replace(/{#if ([^}]+)}([\s\S]*?){\/if}/g, (m, p1, p2) => {
              return append[p1] ? p2 : ''
            })
            .replace(/\{([^}]+)\}/g, (_, p1) => {
              return append[p1];
            })
        : "");
  }

  let $options = $list.cloneNode(true).querySelectorAll("li");
  let $visibleOptions;
  let selectedIndex = -1;
  let enabled = true;

  $input.addEventListener("focus", () => {
    if (!enabled) return;
    $optionContainer.hidden = false;
  });

  $input.addEventListener("blur", close);

  $list.addEventListener("mousedown", e => {
    e.preventDefault();
  });

  $input.addEventListener("input", update);
  update();

  $input.addEventListener("keydown", e => {
    if (e.which === Key.DOWN) {
      e.preventDefault();
      if (selectedIndex > -1) {
        $visibleOptions[selectedIndex].setAttribute("aria-selected", "false");
      }
      selectedIndex =
        selectedIndex === $visibleOptions.length - 1 ? 0 : selectedIndex + 1;
      $visibleOptions[selectedIndex].setAttribute("aria-selected", "true");
    } else if (e.which === Key.UP) {
      e.preventDefault();
      if (selectedIndex > -1) {
        $visibleOptions[selectedIndex].setAttribute("aria-selected", "false");
      }
      selectedIndex =
        selectedIndex <= 0 ? $visibleOptions.length - 1 : selectedIndex - 1;
      $visibleOptions[selectedIndex].setAttribute("aria-selected", "true");
    } else if (e.which === Key.ENTER) {
      e.preventDefault();
      select($visibleOptions[selectedIndex]);
    }
  });

  $list.addEventListener("mouseover", e => {
    if (!e.target) return;
    let $option = e.target.closest("li");
    if (!$option) return;
    if (selectedIndex > -1) {
      $visibleOptions[selectedIndex].setAttribute("aria-selected", "false");
    }
    $option.setAttribute("aria-selected", "true");
    selectedIndex = $visibleOptions.indexOf($option);
  });

  $list.addEventListener("click", e => {
    if (!e.target) return;
    let $option = e.target.closest("li");
    if (!$option) return;
    e.preventDefault();
    select($option);
  });

  function select($option) {
    close();
    $input.value = $option.getAttribute("data-value");
    if ($option.getAttribute("data-code")) {
      $input.setAttribute("data-code", $option.getAttribute("data-code"));
    }
    // $input.setAttribute('readonly', '')
    // $input.classList.add('text-grey')
    // $input.parentNode.className = $input.parentNode.className.replace(
    //   /\bborder-[a-z-]+\b/,
    //   'border-transparent'
    // )
    {
      $input.blur();
    }
    // enabled = false

    if ($option.hasAttribute("data-appended") && append.onSelect) {
      if (append.onSelect()) {
        onSelect();
      }
    } else {
      onSelect();
    }
  }

  function close() {
    $optionContainer.hidden = true;
    onClose();
  }

  function update() {
    let $frag = document.createDocumentFragment();

    // let $sorted = [].slice.call($options).sort((a, b) => {
    //   let dA =
    //     a.textContent.trim().length -
    //     a.textContent.trim().replace(new RegExp($input.value, 'gi')).length
    //   let dB =
    //     b.textContent.trim().length -
    //     b.textContent.trim().replace(new RegExp($input.value, 'gi')).length
    //   return dA - dB
    // })

    if (selectedIndex > -1) {
      $visibleOptions[selectedIndex].setAttribute("aria-selected", "false");
      selectedIndex = -1;
    }

    $visibleOptions = matchSorter(
      [].slice.call($options).filter(x => !x.hasAttribute("data-appended")),
      $input.value,
      {
        keys: [
          $option => {
            return $option.textContent.trim();
          }
        ]
      }
    ).concat(
      [].slice.call($options).filter(x => x.hasAttribute("data-appended"))
    );

    $visibleOptions.forEach(($option, index) => {
      if (!$option.hasAttribute("data-appended")) {
        let $children = $option.children;
        for (let i = 0; i < $children.length; i++) {
          $children[i].innerHTML = $children[i].textContent.replace(
            new RegExp($input.value, "gi"),
            m => {
              return `<mark class="text-current bg-yellow">${m}</mark>`;
            }
          );
        }
      }

      if (index === 0) {
        $option.setAttribute("aria-selected", "true");
      } else {
        $option.setAttribute("aria-selected", "false");
      }
      $frag.appendChild($option);
    });

    if ($visibleOptions.length) {
      selectedIndex = 0;
    }

    $list.innerHTML = $list.querySelector("template").outerHTML;
    $list.appendChild($frag);
  }

  onReady();
}



// WEBPACK FOOTER //
// ./src/js/_combobox.js